<script>
import ApiModeVuetable from '@/src/components/ApiModeVuetable.vue';
import Layout from '@layouts/main.vue'
import Breadcrumb from '@/src/components/Breadcrumb.vue'
import PageHeader from '@/src/components/PageHeader.vue'
import BusinessUnitsService from '@src/services/BusinessUnitsService'
import Pagination from '@src/mixins/pagination.vue'
import Shared from '@src/mixins/shared.vue'
import swalFeedback from '@src/mixins/swalFeedback'
import businessUnitModal from '@src/router/views/intelligence/businessUnit/businessUnitModal'
import validationMixin from '@src/mixins/validation.vue'
import vuetableFormatters from '@src/mixins/vuetableFormatters'
import FilterBar from '@src/components/FilterBar'
import MoreTableButton from '@/src/components/MoreTableButton.vue'
import userChildrenFields from '@/src/fields/childrens/userChildrenFields.vue'
import posChildrenFields from '@/src/fields/childrens/posChildrenFields.vue'
import businessUnitFields from '@/src/fields/intelligence/businessUnitFields.vue'
import { debounce } from 'lodash'

const i18nCommon = 'COMMON'
const i18nKey = 'BUSINESS_UNITS'

export default {
    metaInfo() {
        return {
            title: this.i18nBusinessUnit(2),
        }
    },
    components: {
        ApiModeVuetable,
        Layout,
        Breadcrumb,
        PageHeader,
        businessUnitModal,
        FilterBar,
        MoreTableButton,
    },
    mixins: [
        Pagination,
        Shared,
        swalFeedback,
        validationMixin,
        vuetableFormatters,
        userChildrenFields,
        posChildrenFields,
        businessUnitFields
    ],
    data() {
        return {
            sortOrder: [
                {
                    field: 'name',
                    direction: 'asc',
                },
            ],
            i18nCommon,
            i18nKey,
            modalIsEdit: false,
            modal: {
                id: '',
                name: '',
                contract_value: 0,
                contract_time: 0,
                add_all_users: false,
                add_all_pos: false,
                cost_serving_rule_in_min: 0,
                cost_serving_rule_alert_min: 0,
                cost_serving_rule_out_min: 0,
                chain_billing_apportionment_type: null,
                users: [],
                point_of_sales: [],
                justification_types: [],
            },
            additionalParameters: {},
            data: [],
            perPage: 10,
            css: {},
            filterText: '',
        }
    },
    computed: {
        items() {
            return [
                {
                    text: 'Home',
                    href: '/',
                },
                {
                    text: this.getI18nModified({
                        prefix: 'POS',
                        suffix: 'TITLES.pos',
                        modifier: 2,
                    }),
                    active: true,
                },
                {
                    text: this.getI18nModified({
                        prefix: i18nKey,
                        suffix: 'TITLES.business_unit',
                        modifier: 2,
                    }),
                    active: true,
                },
            ]
        },
    },
    watch: {
        filterText: debounce(function (searchText) {
            this.additionalParameters.search = ''
            if (searchText && searchText.length > 0) {
                this.additionalParameters.search = `name:${searchText}`
            }
            this.refreshTable()
        }, 1000),
    },
    methods: {
        fetch(url, params) {
            return BusinessUnitsService.fetchVuetable(url, params)
        },
        createAdditionalParameters() {
            this.additionalParameters.search = ''
            if (this.filterText && this.filterText.length > 0) {
                this.additionalParameters.search = `name:${this.filterText}`
            }
            return this.additionalParameters
        },
        i18nBusinessUnit(modifier) {
            return this.getI18nModified({
                prefix: i18nKey,
                suffix: 'TITLES.business_unit',
                modifier,
            })
        },
        cleanModal() {
            this.replaceModalData({
                id: '',
                name: '',
                contract_value: 0,
                contract_time: 0,
                cost_serving_rule_in_min: 0,
                cost_serving_rule_alert_min: 0,
                cost_serving_rule_out_min: 0,
                chain_billing_apportionment_type: null,
                users: [],
                point_of_sales: [],
            })
        },
        showModal() {
            this.$nextTick(() => this.$refs.businessUnitModal.showModal())
        },
        openModalToEdit(unity) {
            this.modalIsEdit = false
            this.replaceModalData(unity)
            this.showModal()
        },
        replaceModalData(data) {
            Object.assign(this.modal, data)
        },
        reloadTable() {
            this.$refs.vuetable.reload()
        },
        refreshTable() {
            this.$refs.vuetable.refresh()
        },
    },
}
</script>

<template>
    <Layout>
        <div class="col-12">
            <Breadcrumb :items="items" />
            <div class="row mt-3 mb-3">
                <div class="col-sm-6 form-inline">
                    <filter-bar v-model="filterText" />
                </div>
            </div>
            <div class="card card-pdv">
                <PageHeader :title="i18nBusinessUnit(2)" />
                <div class="card-body">
                    <api-mode-vuetable
                        ref="vuetable"
                        :fetch-data="fetch"
                        :fields="businessUnitFields"
                        :per-page="perPage"
                        :additional-parameters="additionalParameters"
                        :sort-order="sortOrder">
                        <template slot="actions" slot-scope="props">
                            <div class="table-button-container">
                                <more-table-button @onClick="openModalToEdit(props.rowData)" />
                            </div>
                        </template>
                    </api-mode-vuetable>
                </div>
            </div>
        </div>
        <business-unit-modal
            ref="businessUnitModal"
            :modal="modal"
            :modal-is-edit="modalIsEdit"
            @refresh="reloadTable"
        />
    </Layout>
</template>
